import React, { useState } from "react";
import UserDefaultAvatar from "assets/img/user.svg";
import { useUserContext } from "store/contexts/userContext";
import { useHistory } from "react-router-dom";
import { Modal } from "react-responsive-modal";
import TimelineCreateContent from "components/TimelineCreateContent";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import { CreatePostContext } from "store/contexts/createPostContext";
import Button from "components/CustomButton";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import { CSSTransition } from "react-transition-group";
import NewPostTypeSelection from "components/TimelineCreateContent/NewPostTypeSelection";
import classNames from "classnames";

const styles = {
  closeIconStyle: {
    display: "flex",
    justifyContent: "space-between",
    padding: "15px 20px",
    borderBottom: "1px solid #0000001A",
    alignItems: "center",
  },
  buttonRootStyle: {
    display: "flex",
    justifyContent: "center",
  },
  createContent: {
    display: "flex",
    gap: "7px",
    alignItems: " center",
  },
};

export default ({ setOpen, isOpen, defaultType = "" }) => {
  const classes = styles;
  const { user } = useUserContext();
  let history = useHistory();
  const [displayModal, setDisplayModal] = useState(false);
  const { displayCreateButton } = useTeamActionContext();
  const [type, setType] = useState(defaultType);
  const [sOption, setSOption] = useState(null);
  const brightIdeaOptions = [
    {
      ideaId: 1,
      status: "brightIdea",
      name: "Bright Idea",
    },
    {
      ideaId: 2,
      status: "announcement",
      name: "Announcement",
    },
  ];

  const showUserProfile = (id) => {
    history.push(`/profile/${id}`);
  };

  const handleType = (type) => {
    if (type === "brightidea") {
      setSOption(brightIdeaOptions[0]);
    } else {
      setSOption(null);
    }

    setType(type);
  };

  const checkSrc = (e) => {
    e.target.src = UserDefaultAvatar;
  };

  const handleOption = (option) => {
    setSOption(option);
  };

  const handleClose = () => {
    setDisplayModal(false);

    setTimeout(() => {
      setType("");
    }, 500);
  };
  return (
    <>
      <div className="createPostButton">
        <div style={classes.createContent}>
          <div>
            <img
              onError={checkSrc}
              style={{ cursor: "pointer", margin: 0 }}
              onClick={() => showUserProfile(user?.id)}
              className="userAvatar"
              src={user?.avatar ?? UserDefaultAvatar}
              alt={`${user?.full_name}`}
            />
          </div>
          <NewPostTypeSelection
            type={type}
            setType={handleType}
            setDisplayModal={setDisplayModal}
          />
        </div>
      </div>
      <Modal
        classNames={{
          modalContainer: "modalContainer",
          modal:
            type !== "celebration"
              ? "postCreateModal"
              : "peerRecognitionCreateModal",
        }}
        open={displayModal}
        showCloseIcon={false}
        closeOnEsc={false}
        closeOnOverlayClick={false}
        onClose={() => setDisplayModal(false)}
      >
        <div className="write-post">
          <div style={classes.closeIconStyle}>
            {type === "brightidea" && (
              <div className="brightIdea-option-button">
                {brightIdeaOptions.map((option) => (
                  <Button
                    key={option.ideaId}
                    buttonClass={classNames({
                      grad_btn: true,
                      "disable-button":
                        sOption?.ideaId !== option.ideaId ? true : false,
                    })}
                    onClick={() => handleOption(option)}
                  >
                    {option.name}
                  </Button>
                ))}
              </div>
            )}
            {type === "celebration" && (
              <div>
                <h3 style={{ marginBottom: "0px" }}>
                  <span className="fw-bold" style={{ color: "#fa8a06" }}>
                    Peer<span style={{ color: "#0057a2" }}>Recognition</span>
                  </span>
                </h3>
              </div>
            )}
            <CloseIcon
              style={{
                width: "24px",
                height: "24px",
                fill: "#525964",
                cursor: "pointer",
                pointerEvents: "all",
              }}
              onClick={handleClose}
            />
          </div>
          <CreatePostContext.Provider
            value={{
              handleClose,
              sOption,
            }}
          >
            <TimelineCreateContent type={type} setType={setType} />
          </CreatePostContext.Provider>
        </div>
      </Modal>
      <CSSTransition
        in={displayCreateButton}
        timeout={300}
        unmountOnExit
        classNames="dropdown-element"
      >
        <div style={classes.buttonRootStyle}>
          <div
            id="new-content-open-close-container"
            style={{
              bottom: "-55px",
              position: "absolute",
              opacity: 1,
              pointerEvents: "all",
              transition: "all 0.3s ease-in",
            }}
          >
            <Button
              buttonClass="grad_btn full_w h-50 create_post_button"
              onClick={() => setOpen(!isOpen)}
            >
              New Thoughts, Inspirations, Actions
            </Button>
          </div>
        </div>
      </CSSTransition>
    </>
  );
};
